"use strict";

exports.__esModule = true;
exports.default = void 0;

var _utils = require("./utils");

var _GeopointField = _interopRequireDefault(require("./GeopointField"));

var _GeopointPreview = _interopRequireDefault(require("./GeopointPreview"));

var _Geocoder = _interopRequireDefault(require("./Geocoder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "fieldtypes": {
    "geopoint": _utils.getGeopointField
  },
  "fields": {
    "geopoint": _GeopointField.default
  },
  "layouts": {
    "geopointPreview": _GeopointPreview.default,
    "geocoder": _Geocoder.default
  }
};
exports.default = _default;
module.exports = exports.default;